import React from "react";

function FullScreenLoader({ label = "Submitting..." }) {
  return (
    <div className="apple-loader-overlay" role="presentation">
      <div className="apple-loader" role="status" aria-live="polite" aria-label={label}>
        <div className="apple-loader-ring" />
        <div className="apple-loader-text">{label}</div>
      </div>
    </div>
  );
}

export default FullScreenLoader;
